if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.pinchHint = this.querySelector('.product-media-modal__pinch-hint');
        this.pinchHintTimer = null;
        this.pinchHintShown = false;

        const dialog = this.querySelector('.product-media-modal__dialog');
        if (dialog) {
          dialog.addEventListener('pointerup', (event) => event.stopPropagation());
        }

        this.enablePinchZoom();
      }

      enablePinchZoom() {
        this.querySelectorAll('.product-media-modal__image-frame').forEach((frame) => {
          const image = frame.querySelector('img');
          let initialDistance = 0;
          let initialScale = 1;
          let scale = 1;
          let translateX = 0;
          let translateY = 0;
          let panStartX = 0;
          let panStartY = 0;
          let initialTranslateX = 0;
          let initialTranslateY = 0;

          const getDistance = (touches) =>
            Math.hypot(touches[0].clientX - touches[1].clientX, touches[0].clientY - touches[1].clientY);

          const clampTranslation = () => {
            const maxX = (image.clientWidth * (scale - 1)) / 2;
            const maxY = (image.clientHeight * (scale - 1)) / 2;
            translateX = Math.min(maxX, Math.max(-maxX, translateX));
            translateY = Math.min(maxY, Math.max(-maxY, translateY));
          };

          const updateTransform = () => {
            clampTranslation();
            image.style.transform = `translate3d(${translateX}px, ${translateY}px, 0) scale(${scale})`;
            frame.classList.toggle('is-zoomed', scale > 1);
          };

          frame.resetZoom = () => {
            initialDistance = 0;
            scale = 1;
            translateX = 0;
            translateY = 0;
            image.style.transform = '';
            frame.classList.remove('is-zoomed');
          };

          frame.addEventListener(
            'touchstart',
            (event) => {
              if (event.touches.length === 2) {
                this.hidePinchHint(true);
                if (image.dataset.zoomSrc && !image.dataset.zoomLoaded) {
                  image.dataset.zoomLoaded = 'true';
                  image.removeAttribute('srcset');
                  image.removeAttribute('sizes');
                  image.src = image.dataset.zoomSrc;
                }
                initialDistance = getDistance(event.touches);
                initialScale = scale;
              } else if (event.touches.length === 1 && scale > 1) {
                panStartX = event.touches[0].clientX;
                panStartY = event.touches[0].clientY;
                initialTranslateX = translateX;
                initialTranslateY = translateY;
              }
            },
            { passive: true }
          );

          frame.addEventListener(
            'touchmove',
            (event) => {
              if (event.touches.length === 2 && initialDistance) {
                event.preventDefault();
                scale = Math.min(4, Math.max(1, initialScale * (getDistance(event.touches) / initialDistance)));
                if (scale === 1) {
                  translateX = 0;
                  translateY = 0;
                }
                updateTransform();
              } else if (event.touches.length === 1 && scale > 1) {
                event.preventDefault();
                translateX = initialTranslateX + event.touches[0].clientX - panStartX;
                translateY = initialTranslateY + event.touches[0].clientY - panStartY;
                updateTransform();
              }
            },
            { passive: false }
          );

          frame.addEventListener('touchend', (event) => {
            initialDistance = 0;
            if (event.touches.length === 1 && scale > 1) {
              panStartX = event.touches[0].clientX;
              panStartY = event.touches[0].clientY;
              initialTranslateX = translateX;
              initialTranslateY = translateY;
            }
          });
        });
      }

      hide() {
        this.hidePinchHint();
        this.querySelectorAll('.product-media-modal__image-frame').forEach((frame) => frame.resetZoom?.());
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.showPinchHint();
      }

      showPinchHint() {
        if (
          !this.pinchHint ||
          this.pinchHintShown ||
          !window.matchMedia('(max-width: 749px)').matches
        )
          return;

        this.pinchHintShown = true;
        clearTimeout(this.pinchHintTimer);
        this.pinchHint.classList.add('is-visible');
        this.pinchHintTimer = setTimeout(() => this.hidePinchHint(), 3000);
      }

      hidePinchHint(remember = false) {
        clearTimeout(this.pinchHintTimer);
        this.pinchHint?.classList.remove('is-visible');

        if (remember) this.pinchHintShown = true;
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = Math.max((activeMedia.scrollWidth - container.clientWidth) / 2, 0);
        requestAnimationFrame(() => {
          const containerPaddingTop = parseFloat(getComputedStyle(container).paddingTop) || 0;
          const containerTop = container.getBoundingClientRect().top;
          const activeMediaTop = activeMedia.getBoundingClientRect().top;
          container.scrollTop = Math.max(
            container.scrollTop + activeMediaTop - containerTop - containerPaddingTop,
            0
          );
        });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
